import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { readScheduleEditorSession } from "../lib/schedule-editor-session"

/** Component-token insertion handlers stored on the editor session ref. */
export function useScheduleEditorMacroHandlers() {
    const { draftId } = useScheduleEditorIds()
    const session = readScheduleEditorSession(draftId)

    return {
        onComponentTokenInserted: session?.onComponentTokenInserted,
        onRegisterComponentTokenTarget: session?.onRegisterComponentTokenTarget,
        onClearComponentTokenTarget: session?.onClearComponentTokenTarget,
    }
}
